/**
 * useNetworkStatus.js
 *
 * Reactive hook that exposes the current network status.
 * Updates in real-time via @react-native-community/netinfo.
 */

import {useEffect, useState} from 'react';
import NetInfo from '@react-native-community/netinfo';

/**
 * @returns {{ isConnected: boolean, isInternetReachable: boolean|null, type: string }}
 */
const useNetworkStatus = () => {
  const [status, setStatus] = useState({
    isConnected: true,
    isInternetReachable: null,
    type: 'unknown',
  });

  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      setStatus({
        isConnected: !!state.isConnected,
        isInternetReachable: state.isInternetReachable,
        type: state.type,
      });
    });

    // Fetch once on mount
    NetInfo.fetch().then((state) => {
      setStatus({
        isConnected: !!state.isConnected,
        isInternetReachable: state.isInternetReachable,
        type: state.type,
      });
    });

    return () => unsubscribe();
  }, []);

  return status;
};

export default useNetworkStatus;


